import { render, staticRenderFns } from "./sendFeedbackNo.vue?vue&type=template&id=0711938c&scoped=true"
var script = {}
import style0 from "./sendFeedbackNo.vue?vue&type=style&index=0&id=0711938c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711938c",
  null
  
)

export default component.exports